import { useTheme } from '../../hooks/useTheme';

import { ReactComponent as Spinner } from '../../icons/loader.svg';

import './page-loader.scss';

const PageLoader = ({ loading, children }) => {
  const { getThemeVariable } = useTheme();

  if (loading) {
    return (
      <div className="page-loader">
        <Spinner width={48} height={48} style={{ color: getThemeVariable('accent-primary') }} />
      </div>
    );
  }

  return <>{children}</>;
};

export default PageLoader;
